/**
 * Ad / landing context — e.g. ?size_mode=plus on product URLs.
 * No cross-product session memory; URL only (plus inline dataset for first paint).
 */
(function () {
  var PLUS_MIN = 16;
  var MODE_PLUS = "plus";

  function getSearchParams() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (e) {
      return new URLSearchParams();
    }
  }

  function normalizeCtx(raw) {
    var value = String(raw || "").trim().toLowerCase();
    if (value === "plus" || value === "plus-size" || value === "plus_size") {
      return MODE_PLUS;
    }
    return "";
  }

  function getMode() {
    var params = getSearchParams();
    var fromUrl =
      normalizeCtx(params.get("size_mode")) ||
      normalizeCtx(params.get("ctx"));
    if (fromUrl) return fromUrl;
    try {
      if (
        document.documentElement &&
        document.documentElement.dataset.shopSizeMode === "plus"
      ) {
        return MODE_PLUS;
      }
    } catch (e) {}
    return "";
  }

  function hasVariantParam() {
    return getSearchParams().has("variant");
  }

  function isAdPlusLanding() {
    return getMode() === MODE_PLUS && !hasVariantParam();
  }

  function refreshGallery(variantOptionsEl) {
    if (!variantOptionsEl || typeof variantOptionsEl.updateGallery !== "function") {
      return;
    }
    try {
      variantOptionsEl.updateGallery();
    } catch (e) {}
  }

  /**
   * Plus landing: promote plus gallery images only.
   * Do not auto-select a size — dropdown shows "Select Size".
   */
  function applyAdPlusContext() {
    if (!isAdPlusLanding()) return;

    var variantOptionsEl = document.querySelector("variant-options");
    if (!variantOptionsEl) return;

    refreshGallery(variantOptionsEl);
  }

  function boot() {
    if (getMode() !== MODE_PLUS) return;

    if (customElements && customElements.whenDefined) {
      Promise.all([
        customElements.whenDefined("variant-options"),
        customElements.whenDefined("gallery-section"),
      ])
        .then(function () {
          requestAnimationFrame(applyAdPlusContext);
        })
        .catch(function () {
          applyAdPlusContext();
        });
      return;
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", applyAdPlusContext);
    } else {
      applyAdPlusContext();
    }
  }

  window.ShopContext = {
    MODE_PLUS: MODE_PLUS,
    PLUS_MIN: PLUS_MIN,
    getMode: getMode,
    hasVariantParam: hasVariantParam,
    isAdPlusLanding: isAdPlusLanding,
    isAdPlusGallery: function () {
      if (getMode() !== MODE_PLUS) return false;
      if (hasVariantParam()) return false;
      return true;
    },
  };

  boot();
})();
